import type { ClientStatus, TaskExample } from '@frontend/api-types';
import { pluralize } from '@frontend/duck-tape';
import { FlatList, Text, YStack } from '@frontend/web-react';
import { TrendingTaskCard } from '@frontend/web/components';

type CappedTasksProps = {
  clientStatus: ClientStatus;
  examples: TaskExample[];
};

export const CappedTasks = ({ clientStatus, examples }: CappedTasksProps) => {
  const promoTasksRequiredForUnlock = clientStatus?.promotionalFeedDurationInTasks || 0;
  const promoTasksCreated = (clientStatus?.freeTasksCap || 0) - (clientStatus?.tasksRemaining || 0);
  const promoTasksUntilUnlock = promoTasksRequiredForUnlock - promoTasksCreated;

  return (
    <YStack className="gap-sm px-md">
      <YStack className="gap-xs">
        {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
        <Text type="h5">🎁 Recommendations from {clientStatus.promotionalPartnerName || 'Duckbill'}</Text>
        <Text type="caption">
          Create {promoTasksUntilUnlock} {pluralize('tasks', promoTasksUntilUnlock)} to unlock the full Feed experience
        </Text>
        {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
        <YStack className="bg-surfacePrimary h-[8px] w-full items-start rounded-[60px]">
          <div
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="flex rounded-[60px] h-full bg-surfaceBrand"
            style={{ width: `${(promoTasksCreated / promoTasksRequiredForUnlock) * 100}%` }}
          />
        </YStack>
        <Text textAlign="end" type="caption">{`${promoTasksCreated}/${promoTasksRequiredForUnlock} tasks`}</Text>
      </YStack>
      <FlatList
        contentContainerClassName="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3"
        data={examples}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => <TrendingTaskCard example={item} />}
      />
    </YStack>
  );
};
